import React, { useState } from 'react';
import { Volume2, VolumeX, Info, Trash2 } from 'lucide-react';
import { sounds } from '../utils/SoundManager';

const SettingCard = ({ title, description, icon: Icon, children, color }) => (
    <div className="bg-white p-6 rounded-3xl shadow-sm border-2 border-transparent hover:border-gray-100 transition-all flex items-center justify-between">
        <div className="flex items-center gap-4">
            <div className={`p-4 rounded-2xl ${color} text-white`}>
                <Icon size={32} />
            </div>
            <div>
                <h3 className="text-xl font-bold text-gray-800">{title}</h3>
                <p className="text-gray-500 text-sm">{description}</p>
            </div>
        </div>
        <div>
            {children}
        </div>
    </div>
);

const Settings = () => {
    const [muted, setMuted] = useState(sounds.muted);

    const toggleMute = () => {
        const newValue = !muted;
        setMuted(newValue);
        sounds.setMuted(newValue);
        if (!newValue) {
            sounds.playCorrect(); // Test sound
        }
    };

    return (
        <div className="max-w-2xl mx-auto space-y-6 p-4">
            <header className="text-center mb-10">
                <h2 className="text-4xl font-black text-gray-800 mb-2">Ajustes</h2>
                <p className="text-gray-500">Configura tu experiencia en GeoCeuta</p>
            </header>

            <SettingCard
                title="Efectos de Sonido"
                description="Activa o desactiva los sonidos de los ejercicios."
                icon={muted ? VolumeX : Volume2}
                color="bg-brand-blue"
            >
                <button
                    onClick={toggleMute}
                    className={`px-6 py-3 rounded-xl font-bold transition-all ${muted
                            ? 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                            : 'bg-brand-blue text-white shadow-lg hover:scale-105'
                        }`}
                >
                    {muted ? 'Silenciado' : 'Activado'}
                </button>
            </SettingCard>

            <SettingCard
                title="Información"
                description="Sobre la aplicación"
                icon={Info}
                color="bg-brand-purple"
            >
                <span className="text-sm font-bold text-gray-400">v1.2.0</span>
            </SettingCard>
        </div>
    );
};

export default Settings;
